const CreateIcon = () => {
  return (
    <svg
      width="19"
      height="21"
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.79303 10.6522H13.4619M9.62745 6.73079V14.3996M1 8.65217C1 5.04513 1 3.24113 2.12349 2.12104C3.24601 1 5.05394 1 8.66884 1H10.5861C14.201 1 16.0089 1 17.1314 2.12104C18.2549 3.24113 18.2549 5.04513 18.2549 8.65217V12.4783C18.2549 16.0853 18.2549 17.8893 17.1314 19.0094C16.0089 20.1304 14.201 20.1304 10.5861 20.1304H8.66884C5.05394 20.1304 3.24601 20.1304 2.12349 19.0094C1 17.8893 1 16.0853 1 12.4783V8.65217Z"
        stroke="#273244"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default CreateIcon;
